var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSakura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.93,80.4c22.8-1.34,26.68-20.92,26.71-21.12c0.1-0.54-0.22-1.08-0.74-1.25l-5.92-1.91l4.71-3.89 c0.46-0.38,0.54-1.06,0.17-1.54c-0.29-0.38-7.43-9.34-22.12-9.34c-5.56,0-11.5,1.32-17.67,3.91c-1.34,0.56-2.66,1.22-3.98,1.97 c1.82-2.74,3.21-5.58,4.16-8.49c8.83-27.05-9.45-35.97-9.64-36.06c-0.46-0.21-1-0.1-1.31,0.29l-4.02,4.77l-1.84-5.85 c-0.16-0.5-0.61-0.8-1.16-0.77c-0.22,0.02-22.17,2.32-21.01,30.95c0.17,4.13,0.99,8.55,2.45,13.17 c-3.62-5.62-7.67-9.74-12.07-12.29c-5.82-3.37-11.71-5.08-17.49-5.08c-9.09,0-14.65,4.21-14.89,4.39 c-0.48,0.37-0.57,1.06-0.21,1.54l3.72,4.97l-6.81,0c-0.49,0-0.92,0.32-1.06,0.79c-0.09,0.31-2.16,7.65,2.04,15.21 c3.36,6.05,9.7,10.43,18.86,12.99c4.54,1.27,9.93,1.89,16.29,1.9c-7.79,1.28-13.97,3.77-18.4,7.41C0.8,92.6,8.2,108.41,8.28,108.56 c0.22,0.44,0.71,0.7,1.18,0.61l6.19-1.08l-2.37,5.7c-0.22,0.52,0,1.13,0.5,1.4c0.21,0.11,5.17,2.72,12.3,2.72 c6.88,0,17-2.53,26.14-14.58c2.51-3.32,4.48-7.26,5.88-11.75c-0.06,5.4,0.77,10.01,2.51,13.77c9,19.45,23.1,21.54,28.74,21.54 c2.22,0,3.62-0.3,3.67-0.31c0.52-0.11,0.89-0.59,0.87-1.12l-0.21-6.14l5.19,3.06c0.49,0.29,1.12,0.16,1.46-0.3 c0.13-0.18,13.04-18.3-6.15-38.23c-1.39-1.45-2.98-2.8-4.73-4.06C93.4,80.41,97.16,80.63,100.93,80.4z",
    style: {
      fill: "#D7598B"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.6,74.92c-0.67,2.53-4.14,3.85-6.39,2.43c-1.72-1.08-2.26-3.41-1.22-5.13 c0.95-1.58,2.85-2.4,4.64-2.1C57.8,70.49,59.15,72.82,58.6,74.92z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.39,63.9c-0.67,2.53-4.13,3.85-6.39,2.43c-1.72-1.08-2.26-3.41-1.22-5.13 c0.95-1.57,2.85-2.4,4.64-2.1C54.59,59.46,55.95,61.8,55.39,63.9z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.39,53.17c0.95-1.57,2.85-2.4,4.64-2.1c2.17,0.37,3.53,2.7,2.98,4.8 c-0.67,2.53-4.14,3.85-6.39,2.43C57.9,57.22,57.36,54.9,58.39,53.17z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.16,75.92c-0.67,2.53-4.13,3.85-6.39,2.43c-1.72-1.08-2.26-3.41-1.22-5.13 c0.94-1.58,2.85-2.41,4.63-2.1C71.35,71.49,72.71,73.82,72.16,75.92z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.21,63.36c-0.67,2.53-4.13,3.85-6.38,2.43c-1.73-1.08-2.26-3.41-1.22-5.13 c0.94-1.58,2.85-2.4,4.64-2.1C75.41,58.92,76.77,61.26,76.21,63.36z",
    style: {
      fill: "#FFFFFF"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSakura);
export default __webpack_public_path__ + "static/media/sakura.397f5b5c23672dcbeb33123222a42d12.svg";
export { ForwardRef as ReactComponent };